import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const SingleIconItem = ({ data }) => {
  const { icon, description } = data;

  const shouldRenderIcon = !!icon?.value?.src;
  const shouldRenderIconText = !!description?.value;

  return (
    <div className="in-page__banner-content_right-content">
      {shouldRenderIcon && (
        <Image className="in-page__banner-content_right-content_icon" field={icon} />
      )}
      {shouldRenderIconText && (
        <div className="in-page__banner-content_right-content_text">
          <RichText field={description} />
        </div>
      )}
    </div>
  );
};

export default SingleIconItem;
